document.addEventListener('DOMContentLoaded', function () {
  const sidebar = document.querySelector('.lp-ImageText_Sidebar');
  if (!sidebar) return;

  const sidebarItems = document.querySelectorAll('.lp-ImageText_SidebarListItem');
  const scrollItems = document.querySelectorAll('.lp-ImageText_Item');

  // Scroll to section on sidebar item click
  sidebarItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      scrollItems[index].scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  // Highlight sidebar item on scroll
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -80% 0px',
    threshold: 0,
  };

  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const activeIndex = Array.from(scrollItems).indexOf(entry.target);
        sidebarItems.forEach((item, index) => {
          item.classList.toggle('active', index === activeIndex);
        });
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  scrollItems.forEach((item) => observer.observe(item));
});
